"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Validator_1 = require("../../models/common/base/Validator");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var Permissions_1 = require("../../apiServices/rbac/permissions/Permissions");
var AlarmTypes_1 = require("../../api/AlarmTypes");
var AlarmType = /** @class */ (function () {
    function AlarmType() {
        this._validator = new Validator_1.Validator();
        this._alarmTypeAPI = new AlarmTypes_1.AlarmTypes();
    }
    AlarmType.prototype.getAlarmProperties = function (modelId, alarmId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._alarmTypeAPI.getAlarmProperties(modelId, alarmId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AlarmType.prototype.getAlarms = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._alarmTypeAPI.getAlarms(modelId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AlarmType.prototype.getEventProperties = function (modelId, alarmId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._alarmTypeAPI.getEventProperties(modelId, alarmId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AlarmType.prototype.getEvents = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._alarmTypeAPI.getEvents(modelId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return AlarmType;
}());
exports.AlarmType = AlarmType;
//# sourceMappingURL=AlarmType.js.map